import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { useSnackbar } from 'react-simple-snackbar'

import { CandidateContext } from '../../../../context/CandidateContext';
import { UserContext } from '../../../../context/userContext';
import { API } from '../../../../http-common';
import { GROUP } from "../../../../constants";
import { listFilter, CREATE_SUBUSERS_ROLES, ADD_SUBUSERS_STATUSES } from '../../../../helpers/constants';
import { validateInputDni, sanitizeDniInput } from '../../../../hooks/ValidateInput';
import "../../../../assets/css/subusers_page.css";

const EMPTY_NEW_SUB_USER = {
    first_name: "",
    last_name: "",
    document: "",
    document_type: 1,
}

const getDocumentsStatusLabel = (docsStatus) => {
    if (!docsStatus) return '-'
    if (!docsStatus.contract_type) return 'Sin tipo de contrato'
    if (!docsStatus.total) return '-'
    const { signed, total } = docsStatus
    return signed === total ? 'Firmado' : `${signed}/${total} firmados`
}

const getSubProspectStatusLabel = (prospectStatus) =>
    listFilter.find(item => item.status_id.split(',').map(Number).includes(Number(prospectStatus)))?.prospect
    ?? `Estado ${prospectStatus}`

const optionsError = {
    position: 'bottom-right',
    style: {
        backgroundColor: 'var(--bs-red)',
        border: '0',
        color: '#fff',
        fontSize: '20px',
        textAlign: 'center',
        marginBottom: '5rem',
    },
    closeStyle: {
        color: '#fff',
        fontSize: '16px',
        marginRight: '1rem',
    },
}

const optionsSuccess = {
    position: 'bottom-right',
    style: {
        backgroundColor: 'var(--bs-green)',
        border: '0',
        color: '#fff',
        fontSize: '20px',
        textAlign: 'center',
        marginBottom: '5rem',
    },
    closeStyle: {
        color: '#fff',
        fontSize: '16px',
        marginRight: '1rem',
    },
}

export const RelatedSubUsers = () => {
    const history = useHistory()
    const { candidateData, isSubUser } = useContext(CandidateContext)
    const { userData } = useContext(UserContext)

    const [openSnackbarSuccess] = useSnackbar(optionsSuccess)
    const [openSnackbarError] = useSnackbar(optionsError)

    const [subUsers, setSubUsers] = useState([])

    const [addModalOpen, setAddModalOpen] = useState(false)
    const [newSubUser, setNewSubUser] = useState(EMPTY_NEW_SUB_USER)
    const [addLoading, setAddLoading] = useState(false)

    const [moveModalOpen, setMoveModalOpen] = useState(false)
    const [selectedSubUser, setSelectedSubUser] = useState(null)
    const [targetParentDocument, setTargetParentDocument] = useState("")
    const [moveLoading, setMoveLoading] = useState(false)

    const canMoveSubUser = GROUP.EQ_DIRECTORES.includes(userData.role_id)
    const canAddSubUser = CREATE_SUBUSERS_ROLES.includes(userData.role_id) && ADD_SUBUSERS_STATUSES.includes(Number(candidateData?.prospect_status))

    const fetchSubUsers = async (parentId) => {
        try {
            const response = await API.get(`/prospects/sub-prospects/${parentId}`)
            setSubUsers(response.data.data)
        } catch (error) {
            openSnackbarError('Error al obtener los subusuarios')
        }
    }

    useEffect(() => {
        if (candidateData?.id && !isSubUser) {
            fetchSubUsers(candidateData.id)
        }
    }, [candidateData?.id, isSubUser])

    const handleOpenAddModal = () => {
        setNewSubUser(EMPTY_NEW_SUB_USER)
        setAddModalOpen(true)
    }

    const handleAddSubUser = async () => {
        if (!candidateData?.id) {
            openSnackbarError('Todavía se están cargando los datos del usuario, intente nuevamente en unos segundos')
            return
        }
        setAddLoading(true)
        try {
            await API.post(`/prospects/sub-prospects/${candidateData.id}`, {
                first_name: newSubUser.first_name,
                last_name: newSubUser.last_name,
                document: newSubUser.document,
                document_type: newSubUser.document_type,
            })
            openSnackbarSuccess('Subusuario agregado correctamente')
            setAddModalOpen(false)
            fetchSubUsers(candidateData.id)
        } catch (error) {
            openSnackbarError(error.response?.data?.errors?.[0]?.msg || 'Error al agregar el subusuario')
        }
        setAddLoading(false)
    }

    const isNewSubUserValid = newSubUser.first_name.trim().length >= 3
        && newSubUser.last_name.trim().length >= 3
        && validateInputDni(newSubUser.document)

    const handleViewSubUser = (subUser) => {
        history.push({
            pathname: '/admin/details',
            search: '',
            state: { candidato_id: subUser.id, is_balanz: candidateData.is_balanz }
        })
        window.scrollTo(0, 0)
    }

    const handleOpenMoveModal = (subUser) => {
        setSelectedSubUser(subUser)
        setTargetParentDocument("")
        setMoveModalOpen(true)
    }

    const handleMoveSubUser = async () => {
        setMoveLoading(true)
        try {
            await API.post(`/prospects/sub-prospects/${selectedSubUser.id}/move/${targetParentDocument.trim()}`)
            openSnackbarSuccess('Subusuario movido correctamente')
            setMoveModalOpen(false)
            fetchSubUsers(candidateData.id)
        } catch (error) {
            openSnackbarError(error.response?.data?.errors?.[0]?.msg || 'Error al mover el subusuario')
        }
        setMoveLoading(false)
    }

    if (isSubUser) {
        return null
    }

    const hasSubUsers = subUsers.length > 0

    // Sin subusuarios y sin permiso para agregar: no hay nada que mostrar
    if (!hasSubUsers && !canAddSubUser) {
        return null
    }

        return (
        <div className={`col-md-12 item ${hasSubUsers ? 'my-4' : 'my-2'}`} id="container_related_sub_users">
            {hasSubUsers ? (
                <div className="container_history_here">
                    <h4 className="d-block blue_label">Subusuarios relacionados:</h4>
                    <div className="car item_history">
                        <div className="card-body">
                            {canAddSubUser &&
                                <div className="d-flex justify-content-end mb-3">
                                    <button
                                        type="button"
                                        className="btn blue_btn btn-sm"
                                        id="add_sub_user_btn"
                                        disabled={!candidateData?.id}
                                        onClick={handleOpenAddModal}
                                    >
                                        Agregar subusuario
                                    </button>
                                </div>
                            }
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Vínculo</th>
                                        <th>Estado</th>
                                        <th>Estado Documento</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subUsers.map((data) => (
                                        <tr key={data.id}>
                                            <td>{data.complete_name}</td>
                                            <td>{data.is_primary_parent === false ? 'Secundario' : 'Principal'}</td>
                                            <td>{getSubProspectStatusLabel(data.prospect_status)}</td>
                                            <td>{getDocumentsStatusLabel(data.documents_status)}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn blue_btn btn-sm me-2"
                                                    id={`view_sub_user_btn_${data.id}`}
                                                    onClick={() => handleViewSubUser(data)}
                                                >
                                                    Ver subusuario
                                                </button>
                                                {/* Mover reemplaza al usuario principal, solo tiene sentido desde el principal */}
                                                {canMoveSubUser && data.is_primary_parent !== false &&
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm subuser-outline-btn"
                                                        id={`move_sub_user_btn_${data.id}`}
                                                        onClick={() => handleOpenMoveModal(data)}
                                                    >
                                                        Mover a otro usuario
                                                    </button>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="subuser-add-empty">
                    <button
                        type="button"
                        className="subuser-add-link"
                        id="add_sub_user_btn"
                        disabled={!candidateData?.id}
                        onClick={handleOpenAddModal}
                    >
                        <span className="subuser-add-link__icon">+</span>
                        Agregar subusuario
                    </button>
                </div>
            )}

            {/* AGREGAR SUBUSUARIO MODAL */}
            <Modal isOpen={addModalOpen} className="" id="add_sub_user_modal">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={() => setAddModalOpen(false)}>
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title blue_text">
                        Agregar subusuario
                    </p>
                    <form action="#">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Nombre"
                            value={newSubUser.first_name}
                            onChange={e => setNewSubUser({ ...newSubUser, first_name: e.target.value })}
                        />
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="Apellido"
                            value={newSubUser.last_name}
                            onChange={e => setNewSubUser({ ...newSubUser, last_name: e.target.value })}
                        />
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="DNI"
                            inputMode="numeric"
                            maxLength={8}
                            value={newSubUser.document}
                            onChange={e => setNewSubUser({ ...newSubUser, document: sanitizeDniInput(e.target.value) })}
                        />
                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="add_sub_user_confirm_btn"
                                disabled={!isNewSubUserValid || addLoading || !candidateData?.id}
                                onClick={handleAddSubUser}
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="add_sub_user_cancel_btn" onClick={() => setAddModalOpen(false)}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>

            {/* MOVER SUBUSUARIO A OTRO USUARIO MODAL */}
            <Modal isOpen={moveModalOpen} className="" id="move_sub_user_modal">
                <ModalHeader className="justify-content-end">
                    <button className="close bg-transparent border-0" onClick={() => setMoveModalOpen(false)}>
                        <span>&times;</span>
                    </button>
                </ModalHeader>
                <ModalBody className="modal-body">
                    <p className="modal_title blue_text">
                        Mover subusuario a otro usuario
                        {selectedSubUser && <span className="ms-2 name_applicant"><b>{selectedSubUser.complete_name}</b></span>}
                    </p>
                    <form action="#">
                        <input
                            type="text"
                            className="form-control mb-2"
                            placeholder="DNI del usuario destino"
                            inputMode="numeric"
                            maxLength={8}
                            value={targetParentDocument}
                            onChange={e => setTargetParentDocument(sanitizeDniInput(e.target.value))}
                        />
                        <div className="row modal_btns">
                            <button
                                type="button"
                                className="btn blue_btn"
                                id="move_sub_user_confirm_btn"
                                disabled={!validateInputDni(targetParentDocument) || moveLoading}
                                onClick={handleMoveSubUser}
                            >
                                Confirmar
                            </button>
                            <button type="button" className="btn red_btn" id="move_sub_user_cancel_btn" onClick={() => setMoveModalOpen(false)}>
                                Cancelar
                            </button>
                        </div>
                    </form>
                </ModalBody>
            </Modal>
        </div>
    )
}
